import { StringParam, useQueryParam } from "use-query-params";

// The returned param value is NOT sanitized and should be treated
// as raw, untrusted user input. This hook is only intended for use within
// the <DataStoresProvider />'s directory.
export function useOriginParam() {
  return useQueryParam("url", StringParam);
}
